import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {AuditLogService} from '@services/audit-log.service';
import {TableModule} from 'primeng/table';

@Component({
    selector: 'app-audtilog-detail',
    standalone: true,
    imports: [CommonModule, TableModule, RouterModule],
    templateUrl: './audtilog-detail.component.html',
    styleUrl: './audtilog-detail.component.scss'
})
export class AudtilogDetailComponent implements OnInit {
    public audilogId: number;
    public auditlogDetail: any;
    public auditlogDiff: any[] = [];

    constructor(
        private route: ActivatedRoute,
        private auditlogService: AuditLogService
    ) {}

    ngOnInit(): void {
        this.audilogId = this.route.snapshot.params['id'];

        if (this.audilogId) {
            this.GetAuditlogDetailById(this.audilogId);
        }
    }

    GetAuditlogDetailById(AudilogId) {
        this.auditlogService
            .getAuditlogDetailById(AudilogId)
            .subscribe((response: any) => {
                this.auditlogDetail = response;

                const oldVal = JSON.parse(response.oldValue || '{}');
                const newVal = JSON.parse(response.newValue || '{}');
                this.auditlogDiff = [];

                const allKeys = new Set([
                    ...Object.keys(oldVal),
                    ...Object.keys(newVal)
                ]);
                const excludedFields =
                    response.entityName === 'SP_UserPassword' ||
                    response.entityName === 'SP_User'
                        ? ['Password', 'Sault']
                        : [];

                allKeys.forEach((key) => {
                    if (!excludedFields.includes(key)) {
                        let oldValue = oldVal[key] ?? '';
                        let newValue = newVal[key] ?? '';
                        if (
                            key === 'CreatedOn' ||
                            key === 'UpdatedOn' ||
                            key === 'CreatedOnUtc' ||
                            key === 'UpdatedOnUtc' ||
                            key === 'ProductionDate' ||
                            key === 'ExpireDate' ||
                            key === 'PlacementDateTime' ||
                            key === 'ExpectedStartSellingDate' ||
                            key === 'ExpectedEndSellingDate' ||
                            key === 'ChicksTripTime'
                        ) {
                            oldValue = oldValue
                                ? new Date(oldValue).toLocaleString()
                                : '';
                            newValue = newValue
                                ? new Date(newValue).toLocaleString()
                                : '';
                        }

                        this.auditlogDiff.push({
                            field: key,
                            oldValue: oldValue,
                            newValue: newValue
                        });
                    }
                });
            });
    }
}
